// extracted by mini-css-extract-plugin
export var container = "book-call-module--container--dbc5e";
export var iframe = "book-call-module--iframe--16a84";
export var paragraph = "book-call-module--paragraph--4c716";
export var preloader = "book-call-module--preloader--722af";
export var title = "book-call-module--title--2d2a8";